import i18n from "i18next";
import Group from "./Group";

export function getExistGroup(groups: Group[], fromGroups: Group[]): Group[] {
  return groups.filter((group) =>
    fromGroups.some((fromGroup) => fromGroup.title === group.title)
  );
}

export function convertGroupString(group: Group): string {
  if (group.isUnspecifiedGroup) {
    return i18n.t("ThereIsNoGroup");
  } else {
    return group.title;
  }
}

export function makeSelectedGroupsString(selectedGroups: Group[]): string {
  if (selectedGroups.length === 0) {
    return i18n.t("AllGroups");
  } else if (selectedGroups.length === 1) {
    const selectedGroup = selectedGroups[0];
    if (selectedGroup.isUnspecifiedGroup) {
      return i18n.t("ThereIsNoGroup");
    } else {
      return selectedGroup.title;
    }
  } else {
    let value = "";
    selectedGroups.forEach((group, index) => {
      if (group.isUnspecifiedGroup) {
        if (index === 0) {
          value += i18n.t("ThereIsNoGroup");
        } else {
          value += `, ${i18n.t("ThereIsNoGroup")}`;
        }
      } else {
        if (index === 0) {
          value += group.title;
        } else {
          value += `, ${group.title}`;
        }
      }
    });
    return value;
  }
}

export function sortedByNumbers(groups: Group[]): Group[] {
  const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: "base",
  });
  return [...groups].sort((a, b) => collator.compare(a.title, b.title));
}
